export default function LoggedUser() {
    const { accessToken } = JSON.parse(localStorage.getItem('okta-token-storage')) || { accessToken: undefined };

    return {
        FirstName() {
            return accessToken?.claims.FirstName || 'FirstName';
        },
        LastName() {
            return accessToken?.claims.LastName || 'LastName';
        },
    };
}

export function LoggedUserEmailId() {
    const { accessToken } = JSON.parse(localStorage.getItem('okta-token-storage')) || { accessToken: undefined };
    return accessToken?.claims?.email || 'EmailId';
}

/**
 * Filters out retraining tags from the data array if they are present in the last 4 items
 * @param {Array} dataArray - Array of key-value objects
 * @param {Array} retrainingKeys - Array of keys to check for and filter out
 * @returns {Array} - Filtered array without retraining tags if they match, otherwise the original array
 */
export const filterRetrainingTags = (dataArray, retrainingKeys, isNeedRemovedData = false) => {
    if (!dataArray || !Array.isArray(dataArray) || dataArray.length < 4) {
        return dataArray;
    }

    // Get the last 4 items
    const lastFourItems = dataArray.slice(-4);

    // Check if the last 4 items have keys matching the retrainingKeys
    const allKeysMatch = retrainingKeys.every((key, index) => lastFourItems[index]?.key === key);

    // Get the removed items
    if (isNeedRemovedData && allKeysMatch) {
        return dataArray.slice(-4);
    }

    // If all keys match, return array without the last 4 items
    if (allKeysMatch) {
        return dataArray.slice(0, -4);
    }

    // Otherwise return the original array
    return dataArray;
};

export const getFilenameFromUrl = (url) => {
    if (!url) return null;

    try {
        // Extract the path portion before query parameters
        const pathPart = url.split('?')[0];

        // Get the last segment after the final slash which should be the filename
        const segments = pathPart.split('/');
        const filename = segments[segments.length - 1];

        // If filename exists and has an extension, return it
        if (filename && filename.includes('.')) {
            return filename;
        }

        return null;
    } catch (error) {
        // console.error('Error extracting filename from URL:', error);
        return null;
    }
};
